import { request } from '../../../common/request';

const OTP_PATH = `${process.env.REACT_APP_API_URL_AUTHZ}/authz-service/api`;

export const forgotPassword = (identity_number: string): Promise<any> => {
  return request.post<any>({
    url: `${OTP_PATH}/auth/forgot-password`,
    data: {
      identity_number,
    },
  });
};

export const resetPassword = async (userData: {
  identity_number: string;
  temporary_password: string;
  password: string;
  password_verification: string;
}): Promise<any> => {
  return await request.post<any>({
    url: `${OTP_PATH}/auth/reset-password`,
    data: { ...userData },
  });
};
